import React from "react";
import {
  Activity,
  AlertTriangle,
  Globe,
  History,
  Network,
  PenTool,
} from "lucide-react";

/**
 * What an empty conversation offers to ask, in the product the user is in:
 * the same four cards in a Reflector would ask about ports it does not have.
 * Archi reads the product from the same page (`productOf` in apps/archi's
 * prompt), so a suggestion and its answer always speak about the same thing.
 */

export interface Suggestion {
  icon: React.ComponentType<{ className?: string }>;
  text: string;
}

const KONTROL_EDGE: Suggestion[] = [
  { icon: PenTool, text: "Draw how my clouds connect" },
  { icon: Globe, text: "Which internet services use the most bandwidth?" },
  { icon: Network, text: "How is my backbone doing?" },
  { icon: AlertTriangle, text: "What needs attention right now?" },
];

const REFLECTOR: Suggestion[] = [
  { icon: PenTool, text: "Draw my reflectors and their BGP peers" },
  { icon: Activity, text: "Are all my BGP sessions established?" },
  { icon: AlertTriangle, text: "Which reflectors need attention right now?" },
  {
    icon: History,
    text: "What happened to my reflectors in the last 24 hours?",
  },
];

const INSIGHT: Suggestion[] = [
  { icon: PenTool, text: "Draw how my reflectors reach my clouds" },
  { icon: Activity, text: "Which BGP sessions changed state this week?" },
  { icon: Network, text: "How is my backbone doing?" },
  { icon: AlertTriangle, text: "What needs attention right now?" },
];

/** The suggestions for the page the panel is open on. */
export function suggestionsFor(pathname: string): Suggestion[] {
  if (pathname.startsWith("/reflector")) return REFLECTOR;
  if (pathname.startsWith("/insight")) return INSIGHT;
  return KONTROL_EDGE;
}
